
import eventNames from '@/features/common/constants/events';
import eventBus from '@/features/common/eventBus';
import { showErrorAlertDialog, showSuccessAlertDialog } from '@/features/common/helpers';
import { Vue, Component } from 'vue-property-decorator';
import { addCPCMerchantAccount } from '../services/merchantRegistration.services';
import { CarrierAccountType } from '../types';
import { InstallingCarrierType } from '../components/CarrierAccountsTable.vue';

@Component
export default class CpcMyAccountIntegration extends Vue {
  mounted(): void {
    const token = this.getToken();
    if (!token) return;

    this.installCPCMerchantAccount(token);
  }

  private getToken() {
    const status = this.$route.query['registration-status'] as string || '';
    if (!status) return '';

    if (status !== 'SUCCESS') {
      showErrorAlertDialog();
      return '';
    }

    return this.$route.query['token-id'] as string || '';
  }

  private installCPCMerchantAccount = async (token: string) => {
    let installingCarrier: InstallingCarrierType = {
      id: 1,
      code: 'Canadapost',
    };
    const initCarriers: CarrierAccountType[] = [{
      id: 1,
      carrierCode: 'Canadapost',
      countryCode: '',
      accountNumber: '',
      extensions: [],
      isAvailable: true,
    }];

    await new Promise((resolve) => setTimeout(resolve, 2000));

    eventBus.$emit(
      eventNames.SET_INITIAL_INSTALLATION_CARRIER_ACCOUNT,
      installingCarrier,
      initCarriers,
    );

    const response = await addCPCMerchantAccount(token);
    if (!response.successful || !response.data) {
      eventBus.$emit(eventNames.FETCH_CARRIER_ACCOUNTS);
      showErrorAlertDialog(response.errorMessage);
      return;
    }

    installingCarrier = null;
    eventBus.$emit(
      eventNames.SET_INITIAL_INSTALLATION_CARRIER_ACCOUNT,
      installingCarrier,
      [],
    );

    eventBus.$emit(eventNames.FETCH_CARRIER_ACCOUNTS);

    showSuccessAlertDialog(this.$t('carrierAccounts.addAccount.alertDialog.successfulAddition') as string);
  }
}
